import { AccessProvider } from '../../../contexts/accessProvider.tsx';
import { FeedbacksContextProvider } from '../../../contexts/feedbacks/feedbacks.tsx';
import { Role } from '../../../models/enums/role.ts';
import FeedbacksBody from './body.tsx';
import FeedbacksHeader from './header.tsx';

const AdminFeedbacks = () => {
    return (
        <AccessProvider roles={[Role.superAdmin]}>
            <FeedbacksContextProvider>
                <FeedbacksHeader />
                <FeedbacksBody />
            </FeedbacksContextProvider>
        </AccessProvider>
    );
};

export default AdminFeedbacks;
